import React from 'react'

interface SectionIconProps {
  color?: string
  gradient?: boolean
  width?: number
  height?: number
  alt?: string
}

const SectionIcon: React.FC<SectionIconProps> = ({
  color = '#000',
  gradient,
  width = 22,
  height = 22,
  alt = 'Section icon',
}) => {
  const gradientColors = { start: '#ed1c24', end: '#27aae1' }

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 25 21'
      aria-label={alt}
    >
      <title>{alt}</title>
      {gradient ? (
        <defs>
          <linearGradient id='grad1' x1='0%' y1='0%' x2='100%' y2='0%'>
            <stop offset='0%' style={{ stopColor: gradientColors.start, stopOpacity: 1 }} />
            <stop offset='100%' style={{ stopColor: gradientColors.end, stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      ) : null}
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M19.125 5.09961H5.875C5.46079 5.09961 5.125 5.4354 5.125 5.84961V15.1496C5.125 15.5638 5.46079 15.8996 5.875 15.8996H19.125C19.5392 15.8996 19.875 15.5638 19.875 15.1496V5.84961C19.875 5.4354 19.5392 5.09961 19.125 5.09961ZM5.875 3.84961C4.77043 3.84961 3.875 4.74504 3.875 5.84961V15.1496C3.875 16.2542 4.77043 17.1496 5.875 17.1496H19.125C20.2296 17.1496 21.125 16.2542 21.125 15.1496V5.84961C21.125 4.74504 20.2296 3.84961 19.125 3.84961H5.875Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M0.853516 1C0.853516 0.654822 1.13334 0.375 1.47852 0.375H6.27018C6.61536 0.375 6.89518 0.654822 6.89518 1C6.89518 1.34518 6.61536 1.625 6.27018 1.625H1.47852C1.13334 1.625 0.853516 1.34518 0.853516 1Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M9.95898 1C9.95898 0.654822 10.2388 0.375 10.584 0.375H15.3757C15.7208 0.375 16.0007 0.654822 16.0007 1C16.0007 1.34518 15.7208 1.625 15.3757 1.625H10.584C10.2388 1.625 9.95898 1.34518 9.95898 1Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M1 18.25C0.654822 18.25 0.375 17.9702 0.375 17.625L0.375 12.875C0.375 12.5298 0.654822 12.25 1 12.25C1.34518 12.25 1.625 12.5298 1.625 12.875L1.625 17.625C1.625 17.9702 1.34518 18.25 1 18.25Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M1 9.22461C0.654822 9.22461 0.375 8.94479 0.375 8.59961L0.375 3.84961C0.375 3.50443 0.654822 3.22461 1 3.22461C1.34518 3.22461 1.625 3.50443 1.625 3.84961L1.625 8.59961C1.625 8.94479 1.34518 9.22461 1 9.22461Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M18.584 1C18.584 0.654822 18.8638 0.375 19.209 0.375H24.0007C24.3458 0.375 24.6257 0.654822 24.6257 1C24.6257 1.34518 24.3458 1.625 24.0007 1.625H19.209C18.8638 1.625 18.584 1.34518 18.584 1Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M0.853516 20C0.853516 19.6548 1.13334 19.375 1.47852 19.375H6.27018C6.61536 19.375 6.89518 19.6548 6.89518 20C6.89518 20.3452 6.61536 20.625 6.27018 20.625H1.47852C1.13334 20.625 0.853516 20.3452 0.853516 20Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M9.95898 20C9.95898 19.6548 10.2388 19.375 10.584 19.375H15.3757C15.7208 19.375 16.0007 19.6548 16.0007 20C16.0007 20.3452 15.7208 20.625 15.3757 20.625H10.584C10.2388 20.625 9.95898 20.3452 9.95898 20Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M18.584 20C18.584 19.6548 18.8638 19.375 19.209 19.375H24.0007C24.3458 19.375 24.6257 19.6548 24.6257 20C24.6257 20.3452 24.3458 20.625 24.0007 20.625H19.209C18.8638 20.625 18.584 20.3452 18.584 20Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M24 18.25C23.6548 18.25 23.375 17.9702 23.375 17.625L23.375 12.875C23.375 12.5298 23.6548 12.25 24 12.25C24.3452 12.25 24.625 12.5298 24.625 12.875L24.625 17.625C24.625 17.9702 24.3452 18.25 24 18.25Z'
        clipRule='evenodd'
      ></path>
      <path
        fill={gradient ? 'url(#grad1)' : color}
        fillRule='evenodd'
        d='M24 9.22461C23.6548 9.22461 23.375 8.94479 23.375 8.59961L23.375 3.84961C23.375 3.50443 23.6548 3.22461 24 3.22461C24.3452 3.22461 24.625 3.50443 24.625 3.84961L24.625 8.59961C24.625 8.94479 24.3452 9.22461 24 9.22461Z'
        clipRule='evenodd'
      ></path>
    </svg>
  )
}

export default SectionIcon
